import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import "@angular/compiler";
import {AppModule} from './app/app.module';

if(location.hostname.startsWith("irebal.schwab")) {
  enableProdMode();
  if(window){
    window.console.log = function(){};
    window.console.warn = function(){};
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
